import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Badge from "../Badge";
import { Spacing } from "folksam-ui";
import Checkmark from "components/Checkmark/Checkmark";

const style = ({ theme }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    fontFamily: theme.fonts.serif,
    fontWeight: theme.fontWeights.medium,
    fontSize: "16px"
  }
});

const StepHeaderIndicator = ({ classes, total, index, submitted }) => (
  <div className={classes.root}>
    <Badge theme={submitted ? Badge.themes.BADGEDONE : Badge.themes.QUATERNARY}>
      {submitted ? <Checkmark /> : index}
    </Badge>
    <Spacing left={"1"}>{` av ${total}`}</Spacing>
  </div>
);

StepHeaderIndicator.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node
};

export default injectSheet(style)(StepHeaderIndicator);
